import { useAuth } from '@/hooks'
import { SN } from '@acme/core'
import Divider from '@mui/material/Divider'
import { Button } from 'global/components/Button'
import { ServerSideClock } from 'global/components/Clock'
import Dialog from 'global/guides/Dialog'
import { ClockPlusIcon } from 'lucide-react'
import { funcionario } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { invalidateDigitacaoQueries } from '../pages/useDigitacaoData'

export function BaterPontoButton() {
    const { funcionarioSelecionado } = useAuth()

    if (SN.isFalse(funcionarioSelecionado?.registroWeb)) return null

    return [
        <Button
            key="bater-ponto"
            color="primary"
            startIcon={<ClockPlusIcon />}
            href="bater-ponto"
        >
            Bater ponto
        </Button>,
        <Divider key="divider" orientation="vertical" flexItem />,
    ]
}

export default function BaterPontoModal() {
    const { funcionarioSelecionado } = useAuth()

    const empresaId = useStore(state => state.companyId)
    const { mutateAsync, isLoading } =
        funcionario.baterPonto.mutations.useCreate({
            onSuccess: async () => {
                toast.success('Ponto batido com sucesso!')
                await invalidateDigitacaoQueries()
            },
            onError: (error: any) => {
                toast.error(error.message)
                console.error(error)
            },
        })

    return (
        <Dialog.Root
            loading={isLoading}
            height="fit-content"
            width="max-content"
            onSubmit={async () =>
                mutateAsync({
                    empresaId,
                    funcionarioId: funcionarioSelecionado?.id,
                })
            }
        >
            <Dialog.Title>Bater ponto</Dialog.Title>
            <Dialog.Content dividers>
                <ServerSideClock className="px-2 py-4" />
            </Dialog.Content>
            <Dialog.Actions className="justify-between">
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Registrar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
